import {SET_LISTING_ADDITIONAL_CONTENT} from '../action-types';
import {TEMPLATE_ID_HEADER} from '../../utils/constants';

export const setListingAdditionalContent = (payload) => ({
    type: SET_LISTING_ADDITIONAL_CONTENT,
    payload,
});

const generalResponseMapper = (res) => {
    if (res.ok) {
        return res.json();
    }
    return {};
};

const extendListings = ({listings, additionalContent}) => {
    return listings.map((listing) => {
        const extraContent = additionalContent[listing.tripleId] || {};
        return {...listing, ...extraContent};
    });
};

export const fetchListingAdditionalContent = ({
    dispatch,
    segmentKey,
    data,
    listings,
    template,
    basePathPrefix,
    type,
}) => {
    const requestOptions = {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            [TEMPLATE_ID_HEADER]: template,
        },
        body: JSON.stringify({data, type}),
    };

    return fetch(
        `${basePathPrefix}/api/listings-additional-content`,
        requestOptions
    )
        .then(generalResponseMapper)
        .then((additionalContent) =>
            extendListings({listings: listings.listings, additionalContent})
        )
        .then((extendedListings) => {
            dispatch(
                setListingAdditionalContent({
                    listings: extendedListings,
                    cachedListings: {
                        [segmentKey]: {...listings, listings: extendedListings},
                    },
                })
            );
        });
};
